import ApiService from '../api.service';

const Categories = {
  index: (params) => ApiService.query('/api/v2/teachers/me/occurrence_categories', params),
};

export default Categories;
